import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rawMaterialSelect", "quantity", "totalCost", "overheadCost"]
  static values = {
    companyId: String
  }

  connect() {
    this.rawMaterialPrices = new Map()
    this.loadExistingPrices()
  }

  async loadExistingPrices() {
    const promises = this.rawMaterialSelectTargets.map(async (select) => {
      const rawMaterialId = select.value
      if (rawMaterialId && !this.rawMaterialPrices.has(rawMaterialId)) {
        try {
          const response = await fetch(`/api/v1/companies/${this.companyIdValue}/raw_materials/${rawMaterialId}`)
          const data = await response.json()
          this.rawMaterialPrices.set(rawMaterialId, data.price)
        } catch (error) {
          console.error('Error fetching raw material price:', error)
        }
      }
    })

    await Promise.all(promises)
    this.calculateTotalCost()
  }

  async updateRawMaterialPrice(event) {
    const select = event.target
    const rawMaterialId = select.value
    const rowElement = select.closest('.nested-fields')
    
    if (!rawMaterialId) {
      const totalCostField = rowElement.querySelector('[data-heats-target="totalCost"]')
      totalCostField.value = "0.00"
      this.calculateTotalCost()
      return
    }

    if (!this.rawMaterialPrices.has(rawMaterialId)) {
      try {
        const response = await fetch(`/api/v1/companies/${this.companyIdValue}/raw_materials/${rawMaterialId}`)
        const data = await response.json()
        this.rawMaterialPrices.set(rawMaterialId, data.price)
      } catch (error) {
        console.error('Error fetching raw material price:', error)
        return
      }
    }

    this.calculateTotalCost()
  }

  calculateTotalCost() {
    // Calculate total for raw materials
    let rawMaterialsTotal = 0
    this.rawMaterialSelectTargets.forEach((select, index) => {
      const rowElement = select.closest('.nested-fields')
      const quantityField = rowElement.querySelector('[data-heats-target="quantity"]')
      const totalCostField = rowElement.querySelector('[data-heats-target="totalCost"]')
      
      const rawMaterialId = select.value
      const quantity = parseFloat(quantityField.value) || 0
      const price = this.rawMaterialPrices.get(rawMaterialId) || 0
      
      const totalCost = quantity * price
      totalCostField.value = totalCost.toFixed(2)
      rawMaterialsTotal += totalCost
    })

    // Calculate total for overhead costs
    let overheadTotal = 0
    this.overheadCostTargets.forEach(costField => {
      overheadTotal += parseFloat(costField.value) || 0
    })

    // Calculate and display grand total
    const grandTotal = rawMaterialsTotal + overheadTotal
    console.log('Grand Total:', grandTotal.toFixed(2))
  }
}
